export const normalizeIndexColumns = (indexColumn) => {
    if (!indexColumn) {
        return [];
    }
    if (Array.isArray(indexColumn)) {
        return indexColumn;
    }
    return [indexColumn];
};
export const getFirstIndexColumns = (indexColumn) => {
    const normalizedIndexColumns = normalizeIndexColumns(indexColumn);
    return normalizedIndexColumns[0];
};
//# sourceMappingURL=utils.js.map